<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <h2 class="rounded text-center bg-warning text-dark">Counselling Individual Session View</h2>

      <table class="table table-active">
        <tbody class="">
        <p>Centre Details</p>
        <tr>
          <th>Child Name</th>
          <td>{{data.childName}}</td>
        </tr>
        <tr>
          <th>Centre Name</th>
          <td>{{data.centreName}}</td>
        </tr>

        <br>

        <br>
        <p>Session Details</p>
        <tr>
          <th>Session Type</th>
          <td>{{data.type}}</td>
        </tr>

        <tr>
          <th>Mode of Session </th>
          <td>{{data?.sessionMode}}</td>
        </tr>

        <tr>
          <th>Session Date</th>
          <td>{{(getDate(data.date))}}</td>
        </tr>
        <tr>
          <th>Start Time</th>
          <td>{{getTime(data.startTime)}}</td>
        </tr>

        <tr>
          <th>End Time</th>
          <td>{{getTime(data.endTime)}}</td>
        </tr>
        <tr>
          <th>Participants</th>
          <td>{{data?.participants}}</td>
        </tr>


        <br>


<!--        <tr>-->
<!--          <th>Intervention Effectiveness  </th>-->
<!--          <td>{{data?.interventionUsed}}</td>-->
<!--        </tr>-->


        <p>Previous Session</p>

        <tr>
          <th>Intervention Effectiveness</th>
          <td>{{data?.interventionUseful}}</td>
        </tr>
        <tr>
          <th>Intervention Remark</th>
          <td>{{data?.interventionRemarks}}</td>
        </tr>

        <tr>
          <th> Home program Effectiveness</th>
          <td>{{data?.homeProgramEffectiveness}}</td>
        </tr>

        <tr>
          <th>Home Program Remark </th>
          <td>{{data?.remark}}</td>
        </tr>

        <br>
        <tr>
          <th>Challenges Faced</th>
          <td>{{getTopicsCovered(data.challengesFaced)}}</td>
        </tr>
        <tr>
          <th>Highlight of Session</th>
          <td>{{data?.highlight}}</td>
        </tr>
        <tr>
          <th>Intervention  </th>
          <td>{{data?.interventions}}</td>
        </tr>
        <tr>
          <th>Intervention Detail</th>
          <td>{{data?.interventionUsed}}</td>
        </tr>
        <tr>
          <th>Home Program </th>
          <td>{{data?.homeProgram}}</td>
        </tr>
        </tbody>

      </table>

    </div>
    <div class="col-md-12">
      <h2 class="rounded  text-center bg-warning text-dark">Documents & Uploads</h2>
      <!--            <h3>Data will be uploaded to {{mStoragePath}} in {{mDbType}} at {{mPath}} </h3>-->
      <div class="col-md-6">
      <app-file-upload [storagePath]="mStoragePath" [dbPath]="mPath" fileCount="multi"></app-file-upload>
      </div>
        <!--

                 <app-upload [dbType]="mDbType" [path]="mPath" [storagePath]="mStoragePath" ></app-upload>-->

      <h3>Uploaded Documents</h3>
      <!--                  <prettyjson [obj]="data"></prettyjson>-->
      <!--         COPY-->
      <div class="col">

        <div class="cdk-virtual-scroll-data-source-example">
          <cdk-virtual-scroll-viewport orientation="horizontal" itemSize="5" class="example-viewport">
            <div class="d-flex  flex-row">
              <div *cdkVirtualFor="let d of (mDocuments);trackBy:trackByMethod;let i = index" class="example-item ">
                <a (click)="openLink(d.url)">
                  <img [src]="d.url" style="width: 250px; height: 250px" class="img-thumbnail img-fluid">
                </a>
                <p style="flex-grow: 9; font-size: 14px" class="text-center">{{d.description}}</p>
                <button mat-icon-button color="warn" (click)="deleteAdmissionFile(i,d,'documents')">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </cdk-virtual-scroll-viewport>
        </div>

        <!--COPY-->
    </div>
    </div>
    <!--        <div class="col-md-6">-->
<!--    <prettyjson [obj]="documents$|async"></prettyjson>-->

    <!--        </div>-->
  </div>
</div>


